import { Phone, MessageCircle, Minus, Plus, Type } from "lucide-react";
import { useFontSize } from "@/contexts/ThemeContext";
import { useState } from "react";

export default function FloatingCTA() {
  const { scale, setScale, increase, decrease, reset, MIN_SCALE, MAX_SCALE } = useFontSize();
  const [sliderOpen, setSliderOpen] = useState(false);

  const percentage = Math.round(scale * 100);

  return (
    <>
      {/* Font Size - Fixed Top Right Corner */}
      <div className="fixed top-24 right-4 z-50 flex flex-col items-end gap-2">
        <button
          onClick={() => setSliderOpen(!sliderOpen)}
          data-testid="font-size-toggle"
          className={`px-3 py-2 rounded-full border-2 flex items-center gap-1.5 shadow-md hover:shadow-lg transition-all duration-300 text-xs font-semibold ${
            sliderOpen ? 'bg-primary text-primary-foreground border-primary' : 'bg-card text-foreground border-border'
          }`}
          aria-label="Adjust font size"
        >
          <Type className="w-3.5 h-3.5" />
          <span className="whitespace-nowrap">Font Size</span>
        </button>

        {sliderOpen && (
          <div className="bg-card border rounded-xl shadow-xl p-4 w-56" data-testid="font-slider-panel">
            <div className="flex items-center justify-between mb-3">
              <span className="text-xs font-medium text-muted-foreground uppercase tracking-wider">Adjust Size</span>
              <button onClick={reset} className="text-xs text-primary hover:underline" data-testid="font-reset">Reset</button>
            </div>
            <div className="flex items-center gap-2">
              <button
                onClick={decrease}
                disabled={scale <= MIN_SCALE}
                className="w-7 h-7 rounded-full border flex items-center justify-center text-muted-foreground hover:text-foreground hover:border-primary disabled:opacity-30 transition-colors"
                data-testid="font-decrease"
              >
                <Minus className="w-3.5 h-3.5" />
              </button>
              <input
                type="range"
                min={MIN_SCALE * 100}
                max={MAX_SCALE * 100}
                step="5"
                value={Math.round(scale * 100)}
                onChange={(e) => setScale(parseInt(e.target.value) / 100)}
                className="flex-1 h-2 rounded-full appearance-none bg-border cursor-pointer accent-primary"
                data-testid="font-slider"
              />
              <button
                onClick={increase}
                disabled={scale >= MAX_SCALE}
                className="w-7 h-7 rounded-full border flex items-center justify-center text-muted-foreground hover:text-foreground hover:border-primary disabled:opacity-30 transition-colors"
                data-testid="font-increase"
              >
                <Plus className="w-3.5 h-3.5" />
              </button>
            </div>
            <div className="text-center mt-2">
              <span className="text-sm font-heading font-semibold text-foreground">{percentage}%</span>
            </div>
            <div className="flex justify-between mt-1 text-[10px] text-muted-foreground">
              <span>Smaller</span>
              <span>Larger</span>
            </div>
          </div>
        )}
      </div>

      {/* WhatsApp + Call - Fixed Bottom Right */}
      <div className="fixed bottom-6 right-4 z-40 flex flex-col gap-3" data-testid="floating-cta">
        <a
          href="https://wa.me/919815333660?text=Hi%20Dr.%20Ambrish,%20I%20would%20like%20to%20book%20an%20appointment."
          target="_blank"
          rel="noopener noreferrer"
          data-testid="whatsapp-btn"
          className="w-12 h-12 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
          aria-label="Chat on WhatsApp"
        >
          <MessageCircle className="w-6 h-6" />
        </a>
        <a
          href="tel:+919915096633"
          data-testid="call-btn"
          className="w-12 h-12 rounded-full bg-primary text-primary-foreground flex items-center justify-center shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
          aria-label="Call Now"
        >
          <Phone className="w-6 h-6" />
        </a>
      </div>
    </>
  );
}
